import {ActionTree} from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import * as moment from 'moment';

export const actions: ActionTree<any, any> = {

    /**
     * Get list of downloads
     *
     * @param {any} state
     * @param {any} getters
     * @param {any} commit
     * @param {any} dispatch
     * @param {any} rootState
     * @returns {any}
     */

    fetchDownloads: ({state, getters, commit, dispatch, rootState}, force) => {

        if (force) commit('resetDownloadsCache');

        // Pull from store if loaded and cache hasn't expired
        if (state.expire && moment().isBefore(state.expire)) {
            return state.items;
        }

        commit('setDownloadsLoading', true);

        return new Promise((resolve, reject) => {

            axios.get('/downloads')

                .then(({data}) => {

                    commit('setDownloads', data.downloads);
                    commit('setDownloadsLoading', false);
                    resolve(null);
                })
                .catch(error => {

                    commit('setDownloadsLoading', false);
                    reject(error);
                });
        });
    },

    downloadItem: ({state, getters, commit, dispatch, rootState}, id: number) => {
        return new Promise((resolve, reject) => {

            axios({
                method: 'get',
                url: '/downloads/' + id,
                responseType: 'arraybuffer'
            })
                .then(response => {
                   resolve(response);
                })
                .catch(error => {
                    commit('setDownloadsLoading', false);
                    reject(error);
                });
        });
    },

    deleteItem: ({state, getters, commit, dispatch, rootState}, id: number) => {
        return new Promise((resolve, reject) => {

            const items = Object.assign({}, state.items);

            commit('deleteItem',id);

            axios.delete('/downloads/' + id)

                .then(() => {
                    resolve(null);
                })
                .catch(error => {
                    commit('setDownloads', items);
                    reject(error);
                });
        });
    },
};
